<template>
  <div class="menu-config">
    <div class="page-card">
      <div class="d-flex between mb10">
        <div class="d-flex">
          <div class="d-flex mr10">
            <label>菜单ID</label>
            <el-input :placeholder="`请输入`" class="ml10 input150" v-model="queryParams.id" clearable></el-input>
          </div>

          <div class="d-flex mr10">
            <label>父级菜单</label>
            <el-input :placeholder="`请输入`" class="ml10 input150" v-model="queryParams.parentName" clearable></el-input>
          </div>

          <div class="d-flex mr10">
            <label>父级菜单ID</label>
            <el-input :placeholder="`请输入`" class="ml10 input150" v-model="queryParams.parentId" clearable></el-input>
          </div>

          <div class="d-flex mr10">
            <label>菜单名称</label>
            <el-input :placeholder="`请输入`" class="ml10 input150" v-model="queryParams.name" clearable></el-input>
          </div>

          <div class="d-flex">
            <label>菜单路由</label>
            <el-input :placeholder="`请输入`" class="ml10 input150" v-model="queryParams.path" clearable></el-input>
          </div>

          <el-button class="ml20" type="primary" size="mini" @click="search()">查询</el-button>
        </div>
        <el-button class="mr10" type="primary" size="mini" @click="openEdit()">新建</el-button>
      </div>
      <el-table
        border
        ref="list"
        :data="list"
        style="width: 100%;"
        @sort-change="orderChange"
        >
        <el-table-column
            prop="id"
            :label="`菜单ID`"
            align="center"
            sortable="custom"
            sort-by="id"
        ></el-table-column>
        <el-table-column
            prop="parent_id"
            :label="`父级菜单`+'ID'"
            align="center"
            sortable="custom"
            sort-by="parent_id"
        ></el-table-column>
        <el-table-column
            prop="parent_name"
            :label="`父级菜单`"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="name"
            :label="`菜单名称`"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="href"
            :label="`菜单路由`"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="icon"
            :label="`菜单图标`"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="imgurl"
            :label="`菜单图片`"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="order"
            :label="`菜单顺序`"
            align="center"
        ></el-table-column>
        <el-table-column
            prop=""
            :label="`是否按钮`"
            align="center"
        >
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.is_button" :disabled="true" class="input120">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column
            prop=""
            :label="`PDA是否显示`"
            align="center"
        >
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.show_pda" :disabled="true" class="input120">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column
            prop=""
            :label="`是否外链`"
            align="center"
        >
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.outer_chain" :disabled="true" class="input120">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          :label="`文件`"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag class="tag-box" v-for="tag in scope.row.file" :key="tag.id" closable @close="handleTagClose(scope.row)" @click="handleTagClick(tag)"><span class="tag-name">{{ tag.name }}</span></el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop=""
            :label="`操作`"
            align="center"
        >
          <template slot-scope="scope">
            <el-button class="ml5 mb5" size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" v-if="scope.row.is_button === 0 && scope.row.show_pda === 0 && scope.row.outer_chain === 0 && scope.row.parent_id !== 0" @click="openFile(scope.row)">上传</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="`编辑菜单`" :visible.sync="showDetail" width="1000px" append-to-body>
      <label class="mr10">菜单名称</label>
      <el-input :placeholder="`请输入`" class="input200" v-model="detail.name"></el-input>
      <label class="ml10 mr10">父级菜单ID</label>
      <el-input :placeholder="`请输入`" class="input200" v-model="detail.parent_id"></el-input>
      <label class="mr10 ml10">菜单图片</label>
      <el-input :placeholder="`请输入`" class="input200 mt10" v-model="detail.imgurl"></el-input>
      <br />
      <label class="mr10">菜单图标</label>
      <el-input :placeholder="`请输入`" class="input200 mt10" v-model="detail.icon"></el-input>
      <label class="ml10 mr10">菜单顺序</label>
      <el-input :placeholder="`请输入`" class="input200 mb10" v-model="detail.order"></el-input>
      <br />
      <label class="mr10">菜单路由</label>
      <el-input :placeholder="`请输入`" class="input700 mb20" v-model="detail.href"></el-input>
      <br />
      <label class="mr10">是否按钮</label>
      <el-radio-group v-model="detail.is_button"  class="input120">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
      <label class="mr10 ml20">PDA是否显示</label>
      <el-radio-group v-model="detail.show_pda"  class="input120">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
      <label class="mr10 ml20">是否外链</label>
      <el-radio-group v-model="detail.outer_chain"  class="input120">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
      <label class="mr10 ml20">PC是否显示</label>
      <el-radio-group v-model="detail.show_pc"  class="input120">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
      <div class="d-flex right mt10">
        <el-button class="mb10" type="primary" size="mini" @click="edit()">保存</el-button>
      </div>
    </el-dialog>

    <!-- 附件上传 -->
    <multi-file-upload ref="MultiFileUpload" :type="'*'" :limit="1" @complete="getFiles" />
  </div>
</template>

<script>
import { systemMenu, systemMenuFile } from '@/api.js'
// 文件上传
import MultiFileUpload from '@/components/common/MultiFileUpload.vue'
export default {
  name: 'menuConfig',
  components: {
    MultiFileUpload,
  },
  data() {
    return {
      queryParams: {
        id: '',
        parentId: '',
        parentName: '',
        name: '',
        path: ''
      },
      menuList: [], // 从接口获取到的菜单原数据
      filterList: [], // 筛选过滤后的列表数据
      list: [],
      showDetail: false,
      detail: {},
      loading: null,
      fileRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$request('get', systemMenu)
      .then((res) => {
        if (res) {
          this.menuList = this.handleList(res)
          this.list = this.menuList.concat([])
          this.filterList = this.list.concat([])
        }
      })
    },
    search() {
      // 搜索过滤
      this.loading = this.loading || this.$loading({
        lock: true,
        text: '查询中...',
        fullscreen: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 恢复排序
      const { list : listInstance } = this.$refs
      listInstance && listInstance.clearSort()
      
      // 过滤
      const { id, parentId, name, path, parentName } = this.queryParams
      const { menuList } = this
      const idString = id.trim()
      const parentIdString = parentId.trim()
      const parentNameString = parentName.trim()
      const nameString = name.trim()
      const pathString = path.trim()
      const list = menuList.filter(i => idString ? `${i.id}`.includes(idString) : true)
                  .filter(i => parentIdString ? `${i.parent_id}`.includes(parentIdString) : true)
                  .filter(i => parentNameString ? `${i.parent_name}`.includes(parentNameString) : true)
                  .filter(i => nameString ? i.name.includes(nameString) : true)
                  .filter(i => pathString ? (i.href || '').includes(pathString) : true)
      
      this.filterList = list
      this.list = this.filterList.concat([])
      if (this.loading) {
        this.loading.close()
        this.loading = null
      }
    },
    orderChange(item) {
      // 排序方法
      const { column, order } = item
      const { sortBy } = column
      
      this.orderList(sortBy, order)
    },
    orderList(column, order) {
      // 排序列表
      if (order === 'ascending') {
        this.list.sort((a, b) => (a[column] || 0) - (b[column] || 0))
      } else if (order === 'descending') {
        this.list.sort((a, b) => (b[column] || 0) - (a[column] || 0))
      } else {
        this.list = this.filterList.concat([])
      }
    },
    handleList(menu) {
      // 处理菜单数据，整理成列表
      const list = []
      menu.forEach(i => {
        list.push(i)
        i.children && i.children.forEach(c => {
          c.parent_name = i.name
          list.push(c)
          c.children && c.children.forEach(b => {
            b.parent_name = c.name
            list.push(b)
          })
        })
      })
      return list
    },
    openEdit(item = { show_pc : 1 }) {
      this.detail = item
      this.showDetail = true
    },
    edit() {
      let url = systemMenu
      const { id } = this.detail
      if (id) {
        url = `${systemMenu}/${id}`
      }

      const {
        name, parent_id, is_button, href, icon, order, imgurl, show_pda, outer_chain, show_pc
      } = this.detail

      const params = {
        name, parent_id, is_button, href, icon, order, imgurl, show_pda, outer_chain, show_pc
      }
      this.$request('post', url, params)
      .then((res) => {
        if (res) {
          // this.$message.success('操作成功')
          this.$message.success(`操作成功`)
          this.showDetail = false
          this.getList()
        }
      })
    },
    openFile(row) {
      this.fileRow = row
      const { MultiFileUpload } = this.$refs
      MultiFileUpload && MultiFileUpload.open()
    },
    getFiles(files){
      const file_ids = files.map(i => i.fileId)
      const query = [
        {
          menu_id: this.fileRow.id,
          file_ids: file_ids,
        }
      ]
      this.$request('post', systemMenuFile, {data: query}).then((res) => {
        if (res) {
          this.$message.success(`操作成功`)
          this.getList()
          this.fileRow = {}
          this.$parent.$parent.getMenu()
        }
      })
    },
    handleTagClose(row) {
      const query = [
        {
          menu_id: row.id,
          file_ids: [],
        }
      ]
      this.$request('post', systemMenuFile, {data: query}).then((res) => {
        if (res) {
          this.$message.success(`操作成功`)
          this.getList()
          this.$parent.$parent.getMenu()
        }
      })
    },
    handleTagClick(tag) {
      window.open(tag.url, '_blank')
    }
  }
}
</script>

<style lang="scss">
.tag-box {
  display: flex;
  align-items: baseline;

  .tag-name {
    display: inline-block;
    width: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>